export default __webpack_public_path__ + "static/media/pizzabrigadeiro.0002f124.jpg";